import { Check, X, Clock, AlertTriangle } from 'lucide-react'
import { Badge } from '@/components/ui/badge'

interface LeadStatusBadgeProps {
  status: 'pending' | 'approved' | 'rejected'
  size?: 'sm' | 'md'
}

export function LeadStatusBadge({ status, size = 'md' }: LeadStatusBadgeProps) {
  const getStatusConfig = (status: string) => {
    switch (status) {
      case 'approved':
        return {
          icon: Check,
          label: 'Approved',
          variant: 'secondary' as const,
          className: 'text-green-600 bg-green-50 border-green-200'
        }
      case 'rejected':
        return {
          icon: X,
          label: 'Rejected',
          variant: 'secondary' as const,
          className: 'text-red-600 bg-red-50 border-red-200'
        }
      case 'pending':
        return {
          icon: Clock,
          label: 'Pending',
          variant: 'secondary' as const,
          className: 'text-yellow-600 bg-yellow-50 border-yellow-200'
        }
      default:
        return {
          icon: AlertTriangle,
          label: 'Unknown',
          variant: 'secondary' as const,
          className: 'text-gray-600 bg-gray-50 border-gray-200'
        }
    }
  }
  
  const config = getStatusConfig(status)
  const Icon = config.icon
  const isSmall = size === 'sm'
  
  return (
    <Badge 
      variant={config.variant}
      className={`${config.className} gap-1 ${isSmall ? 'text-xs px-1.5 py-0.5' : ''}`}
    >
      <Icon className={`${isSmall ? 'h-2.5 w-2.5' : 'h-3 w-3'}`} />
      {!isSmall && config.label}
    </Badge>
  )
}